import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { prepareTablePdf } from "./prepareTable";
import Logo from "../../assets/nutrackx.png";
import moment from "moment";



// async function downloadTaskTablePdf(columns, data, fromDate, toDate, employeName) {
//   if (!data || data.length === 0) {
//     alert("No data available to download");
//     return;
//   }

//   const { headers, body } = prepareTablePdf(columns, data);

//   // Use landscape mode for more columns
//   const doc = new jsPDF("l", "pt"); // "l" for landscape

//   // Add company logo (top-left)
//   const imgWidth = 120;
//   const imgHeight = 100;
//   const logo = new Image();
//   logo.src = Logo;

//   await new Promise((resolve) => {
//     logo.onload = resolve;
//   });


//   doc.addImage(logo, "PNG", 20, -20, imgWidth, imgHeight);

//   // Add title
//   const pageWidth = doc.internal.pageSize.getWidth();
//   const centerX = pageWidth / 2;
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(16);
//   doc.setTextColor(40, 40, 40);
//   doc.text("Task Report", centerX, 30, { align: "center" });

//   // Add date and record count
//   doc.setFont("normal");
//   doc.setFontSize(10);
//   doc.setTextColor(100, 100, 100);
//   doc.text(`Generated on: ${moment(new Date().toLocaleDateString()).format("DD-MMM-YYYY")}`, centerX, 50, { align: "center" });
//   // doc.text(`Total Records: ${data.length}`, centerX, 65, { align: "center" });

//   // Add date range and employeName (top-right)
//   const rightMargin = 40;
//   const textRightX = pageWidth - rightMargin; // 
//   doc.setFontSize(10);
//   doc.setTextColor(100, 100, 100);
//   doc.text(`From: ${fromDate}`, textRightX, 30, { align: "right" });
//   doc.text(`To: ${toDate}`, textRightX, 45, { align: "right" });
//   // doc.text(`Employe Name: ${employeName}`, textRightX, 60, { align: "right" });


//   // ✅ Orange Row above table
//   const tableTopY = 80;
//   const rectHeight = 20;
//   doc.setFillColor(255, 204, 153); // Light orange
//   doc.rect(0, tableTopY - rectHeight, pageWidth, rectHeight, "F"); // Full-width rectangle

//   doc.setTextColor(0);
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(10);
//   doc.text(`Employee Name: ${employeName}`, 40, tableTopY - 6); // Inside the orange row


//   autoTable(doc, {
//     head: [headers],
//     body: body,
//     startY: 80,
//     styles: {
//       fontSize: 7, // Smaller font to fit more columns
//       halign: "center",
//       valign: "middle",
//       lineColor: [0, 0, 0],
//       lineWidth: 0.1,
//       cellPadding: 3,
//     },
//     headStyles: {
//       fillColor: [220, 220, 220],
//       textColor: [0, 0, 0],
//       fontStyle: "bold",
//       halign: "center",
//       fontSize: 8,
//       lineWidth: 0.3,
//     },
//     alternateRowStyles: {
//       fillColor: [255, 255, 255],
//     },
//     margin: { top: 80 },
//     tableWidth: 'auto',
//     // Allow table to break across pages
//     pageBreak: 'auto',
//     // Reduce column width automatically
//     columnStyles: {
//       0: { cellWidth: 'auto' }, // S.No
//       1: { cellWidth: 'auto' }, // Subject
//       2: { cellWidth: 'auto' }, // Project Title
//       // Add more specific column widths if needed
//     }
//   });



//   // ✅ Bottom section
//   const finalY = doc.lastAutoTable.finalY + 30;
//   const boxHeight = 20;

//   // Count tasks by status dynamically
// const statusCounts = data.reduce((acc, task) => {
//   switch (task.STATUS) {
//     case "On Hold":
//       acc.onHold++;
//       break;
//     case "In Process":
//       acc.inProcess++;
//       break;
//     case "Completed":
//       acc.completed++;
//       break;
//     case "Assigned":
//       acc.assigned++;
//       break;
//     case "Rejected":
//       acc.rejected++;
//       break;
//     default:
//       break;
//   }
//   return acc;
// }, {
//   onHold: 0,
//   inProcess: 0,
//   completed: 0,
//   assigned: 0,
//   rejected: 0,
// });

// //  Dynamic boxes
// const boxes = [
//   {
//     label: `Total Records: ${data.length}`,
//     bgColor: [230, 230, 230], // light gray
//   },
//   { label: `On Hold: ${statusCounts.onHold}`, bgColor: [255, 255, 204] },
//   { label: `In Process: ${statusCounts.inProcess}`, bgColor: [204, 255, 229] },
//   { label: `Completed: ${statusCounts.completed}`, bgColor: [204, 229, 255] },
//   { label: `Assigned: ${statusCounts.assigned}`, bgColor: [255, 229, 204] },
//   { label: `Rejected: ${statusCounts.rejected}`, bgColor: [255, 204, 204] },
// ];


//   // Layout calculations
//   const pageWidthFooter = doc.internal.pageSize.getWidth();
//   const boxWidth = 100;
//   const totalBoxes = boxes.length;
//   const totalBoxesWidth = totalBoxes * boxWidth;
//   const availableSpace = pageWidthFooter - totalBoxesWidth;
//   const gapBetween = availableSpace / (totalBoxes + 1); // space-between style

//   // 2️⃣ Draw all boxes with centered text
//   let currentX = gapBetween;

//   boxes.forEach(({ label, bgColor }) => {
//     // Box background
//     doc.setFillColor(...bgColor);
//     doc.rect(currentX, finalY, boxWidth, boxHeight, "F");

//     // Centered text
//     const textWidth = doc.getTextWidth(label);
//     const textX = currentX + (boxWidth / 2) - (textWidth / 2);
//     const textY = finalY + (boxHeight / 2) + 3;

//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(10);
//     doc.setTextColor(0);
//     doc.text(label, textX, textY);

//     // Move to next
//     currentX += boxWidth + gapBetween;
//   });




//   doc.save(`tasks-report-${new Date().toISOString().split('T')[0]}.pdf`);
// }

async function downloadTaskTablePdf(columns, data, fromDate, toDate, employeName) {
  if (!data || data.length === 0) {
    alert("No data available");
    return;
  }
  const doc = new jsPDF("l", "pt");
  const pageWidth = doc.internal.pageSize.getWidth();

  // Add company logo (top-left)
  const imgWidth = 120;
  const imgHeight = 100;
  const logo = new Image();
  logo.src = Logo;

  await new Promise((resolve) => {
    logo.onload = resolve;
  });


  doc.addImage(logo, "PNG", 20, -20, imgWidth, imgHeight);

  // Add title
  const centerX = pageWidth / 2;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor(40, 40, 40);
  doc.text("Task Report", centerX, 30, { align: "center" });

  // Add date and record count
  doc.setFont("normal");
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text(`Generated on: ${moment(new Date().toLocaleDateString()).format("DD-MMM-YYYY")}`, centerX, 50, { align: "center" });
  // doc.text(`Total Records: ${data.length}`, centerX, 65, { align: "center" });

  // Add date range and employeName (top-right)
  const rightMargin = 40;
  const textRightX = pageWidth - rightMargin; // 
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text(`From: ${fromDate}`, textRightX, 30, { align: "right" });
  doc.text(`To: ${toDate}`, textRightX, 45, { align: "right" });
  doc.text(`Employe Name: ${employeName}`, textRightX, 60, { align: "right" });


  let startY = 100;

  // Group By Project
  const grouped = {};

  data.forEach(task => {
    const project = task.TITLE || "No Project";

    if (!grouped[project]) {
      grouped[project] = [];
    }

    grouped[project].push(task);
  });

  // Group Wise Project
  Object.keys(grouped).forEach(projectName => {

    // Project Heading
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setFillColor(240, 240, 240);
    doc.rect(40, startY, pageWidth - 90, 20, "F");
    doc.text(`Project: ${projectName}`, 50, startY + 14);

    startY += 30;

    const body = [];

    grouped[projectName].forEach((task, index) => {

      //  Row 1
      body.push([
        index + 1,
        task.CLIENTTITLE || "-",
        task.WORK_TYPE || "-",
        task.ASSIGNDATE || "-",
        task.DUE_DATE || "-",
        task.COMPLAINBY || "-",
        task.STATUS || "-",
        task.COMPLETEDATE || "-",
        task.COMPLETE_DURATION_DAYS || "-"
      ]);

      //  Row 2 Full Width Description
      body.push([
        {
          content: "Description: " + (task.DESCRIPTION || "-"),
          colSpan: 9,
          styles: { fontStyle: "italic", halign: "left" }
        }
      ]);

      //  Row 3 Dev + Client (50/50)
      body.push([
        {
          content: "Developer Remarks: " + (task.DEVELOPER_REVIEW ? task.DEVELOPER_REVIEW.replace(/\n/g, " ") : "-"),
          colSpan: 4,
          styles: { halign: "left" }
        },
        {
          content: "Client Review: " + (task.REMARKS || "-"),
          colSpan: 5,
          styles: { halign: "left" }
        }
      ]);

    });

    autoTable(doc, {
      head: [[
        "S.No",
        "Subject",
        "Features",
        "Assign Date",
        "Due Date",
        "Complain By",
        "Status",
        "Completed Date",
        "Days Taken",
      ]],
      body: body,
      startY: startY,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 5,
        overflow: "linebreak",
        valign: "top"
      },
      headStyles: {
        fillColor: [220, 220, 220],
        textColor: 0,
        fontSize: 9,
        halign: "center"
      },
      columnStyles: {
        0: { cellWidth: 40 },
        1: { cellWidth: 100 },
        2: { cellWidth: 90 },
        3: { cellWidth: 90 },
        4: { cellWidth: 90 },
        5: { cellWidth: 90 },
        6: { cellWidth: 70 },
        7: { cellWidth: 90 },
        8: { cellWidth: 110 },
      },
      margin: { left: 40, right: 40 },
      pageBreak: "auto",
      didDrawPage: function (data) {
        const pageCount = doc.getNumberOfPages();
        const pageHeight = doc.internal.pageSize.height;

        doc.setFontSize(10);
        doc.setTextColor(100);

        doc.text(
          `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
          doc.internal.pageSize.width - 30,
          pageHeight - 10,
          { align: "right" }
        );
      }
    });

    startY = doc.lastAutoTable.finalY + 30;

  });


  doc.save(`tasks-report-${new Date().toISOString().split('T')[0]}.pdf`);
}




export default downloadTaskTablePdf;